import { Player, useVideoTutorial } from '@/entities/video-tutorial'

import {
	Modal,
	ModalContent,
	ModalHeader,
	ModalTitle,
	ModalTrigger,
} from '@/shared/components/ui/modal'
import { Skeleton } from '@/shared/components/ui/skeleton'

import { ChatMessageArtifactCard } from './ChatMessageArtifactCard'

export function ChatMessageArtifactVideo({ id }: { id: string }) {
	const videoQuery = useVideoTutorial(id)

	if (videoQuery.isLoading) return <Skeleton className='h-20 w-48 rounded-lg' />
	const video = videoQuery.data
	if (!video) return null

	return (
		<Modal>
			<ModalTrigger asChild>
				<ChatMessageArtifactCard video={video} />
			</ModalTrigger>
			<ModalContent className='max-w-4xl'>
				<ModalHeader>
					<ModalTitle>{video.name}</ModalTitle>
				</ModalHeader>
				<div className='h-full w-full rounded-lg'>
					<Player
						src={video.url.replace('iframe', 'manifest/video.m3u8')}
						poster={video.thumbnail}
					/>
				</div>
			</ModalContent>
		</Modal>
	)
}
